import { Component, Input, OnInit, inject } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { EvidenceSampleEditModel } from "../../../shared/models";
import { AdvEffDataService } from "../../../shared/services";
import { EffExpansionPanelComponent } from "../../common/eff-expansion-panel/eff-expansion-panel.component";

@Component({
    selector: "eff-evidence-instructions-info-box",
    templateUrl: "./eff-evidence-instructions-info-box.component.html",
    styleUrls: ["./eff-evidence-instructions-info-box.component.scss"],
    imports: [TranslocoPipe, EffExpansionPanelComponent]
})
export class EffEvidenceInstructionsInfoBoxComponent implements OnInit {
    private _ds = inject(AdvEffDataService);

    @Input() effectivenessGuid: string;
    @Input() samples: EvidenceSampleEditModel[];
    @Input() isCollapsed = false;
    @Input() instructions: string = "";
    @Input() panelOpenState: boolean = false;

    ngOnInit(): void {
        this.loadData();
    }

    loadData() {
        if (!this.samples) {
            if (!this.isCollapsed && this.effectivenessGuid) {
                this._ds.getEvidenceSamples(this.effectivenessGuid).subscribe((data) => {
                    this.samples = data;
                });
            }
        }
    }
}
